module.exports = __webpack_public_path__ + "static/img/banner-img.5d1aa74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedProcessPhone/banner-img.png
// module id = KFc7
// module chunks = 0